import { ApiService } from '@core/services';
import { sessionKeys } from '@core/storage';
import { Api } from '@core/types';
import { translations } from '@packout/core';
import { Dispatch } from 'redux';
import { FETCH_TRANSLATIONS, FETCH_TRANSLATIONS_ERROR, FETCH_TRANSLATIONS_SUCCESS } from './actions';

export const fetchTranslations = (cultureCode: string) => async (dispatch: Dispatch) => {
  dispatch({
    type: FETCH_TRANSLATIONS,
  });

  try {
    const requestParams = {
      method: Api.Method.POST,
      controller: 'localisation',
      slug: 'localisations',
      params: {
        cultureCode,
        keys: translations.keys,
      },
      cacheKey: `${sessionKeys.translations}|${new Date().getDate()}|${cultureCode}`,
    };

    const response = await ApiService.request<Api.IFetchTranslationsResponse>(requestParams);

    dispatch({
      type: FETCH_TRANSLATIONS_SUCCESS,
      payload: response.Localisations,
    });
  } catch (e) {
    dispatch({
      type: FETCH_TRANSLATIONS_ERROR,
      payload: e,
    });
  }
};
